const clampOrMin = (min, max, val) => {
  // invalid type means return the max
  if (undefined === val) return min;
  if (!Number.isSafeInteger(val)) return min;

  // invalid value means return the limits
  if (val <= min) return min;
  if (val >= max) return max;

  return val;
};

// noinspection JSUnusedGlobalSymbols
export default clampOrMin;
